import React from 'react';
import { Button, Paper, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as LinkRouter } from 'react-router-dom';

function RecoverPasswordSuccess() {
  const { t } = useTranslation('recover_password');

  return (
    <Paper square elevation={3} component="form" sx={{ p: 5 }}>
      <Typography variant="h5">{t('recover_password')}</Typography>
      <Typography variant="body1" sx={{ fontWeight: 600, mt: 4.3 }}>
        {t('new_password_sended')}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1.5, mb: 5.75 }}>
        {t('email_without_access')}
      </Typography>

      <Link to="/login" component={LinkRouter} sx={{ textDecoration: 'none' }}>
        <Button fullWidth size="large">
          {t('back_to_login')}
        </Button>
      </Link>
    </Paper>
  );
}

export default RecoverPasswordSuccess;
